import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propShape, propStr, propChildren, propBool, } from '../../../../helpers/custom-prop-types';
import SlideSearchFilterListItemInner from './SlideSearchFilterListItemInner';
const SlideSearchFilterListItem = (props) => {
    const { children, className, isImageType, slideSearchFilter } = props;
    const { id, image: backgroundImage, name } = slideSearchFilter;
    const style = useMemo(() => backgroundImage ? { backgroundImage: `url('${backgroundImage}')` } : null, [backgroundImage]);
    return (_jsx(SlideSearchFilterListItemInner, Object.assign({ className: clsx(className, 'category_item_image_box'), id: id, labelClassName: clsx('category_item_check_label', isImageType ? 'category_item_image_button' : 'category_item_tag_button'), name: name, style: style }, { children: children })));
};
SlideSearchFilterListItem.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    isImageType: propBool(),
    slideSearchFilter: propShape().isRequired,
};
SlideSearchFilterListItem.defaultProps = {
    className: '',
    isImageType: false,
};
export default SlideSearchFilterListItem;
